<template>
  <AbsoluteLayout :class="classes">
    <FlexboxLayout class="circle" :style="styles" top="0" left="0" justifyContent="center" @tap="$emit('tap', $event)" @click="$emit('click', $event)" @touch="touch" role="img" :aria-label="avatarLabel">
      <AgImage v-if="showImage" round class="image" :src="image" stretch="aspectFill" aria-hidden="true" />
      <slot v-else-if="showSlot" name="default">
        <AgIcon set="agila" type="animals" :size="size" :decorative="true" />
      </slot>
    </FlexboxLayout>
    <AgLoader v-if="loading" class="loader" top="0" left="0" />
    <FlexboxLayout v-if="edit" class="edit-button" top="62" left="62" justifyContent="center" alignItems="center" @tap="$emit('edit')" @click="$emit('edit')" role="button" aria-label="Edit avatar">
      <AgIcon type="pen" :size="14" :decorative="true" />
    </FlexboxLayout>
  </AbsoluteLayout>
</template>

<script>

import env from '@/helpers/env'
import { colors } from '@/helpers/ui'
import AgLoader from '@/components/Loader'

export default {
  components: {
    AgLoader
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: ''
    },
    touchable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    frameless: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    }
  },
  data: () => ({
    active: false,
    size: 78
  }),
  computed: {
    classes () {
      return {
        'avatar': true,
        'edit': this.edit,
        'filled': this.filled,
        'active': this.active,
        'loading': this.loading,
        'frameless': this.frameless
      }
    },
    styles () {
      return {
        'border-color': this.color ? this.color : colors.primary
      }
    },
    filled () {
      return this.showImage
    },
    showImage () {
      return this.image.length > 0
    },
    showSlot () {
      return !this.loading
    },
    avatarLabel () {
      if (this.showImage) {
        return 'User avatar'
      }
      return 'Default avatar'
    }
  },
  methods: {
    touch (event) {
      if (this.touchable) {
        if (event.action === 'down') {
          this.active = true
        } else if (event.action === 'up' || event.action === 'cancel') {
          setTimeout(() => { this.active = false }, 200)
        }
      }
    }
  },
  mounted () {
    if (env.isWeb) {
      let checkDocumentWidth = () => {
        this.size = document.body.offsetWidth < 800 ? 78 : 80;
      }
      
      window.addEventListener('resize', checkDocumentWidth)

      checkDocumentWidth()
    }
  }
}

</script>

<style scoped lang="scss">

.avatar {
  .circle {
    background-color: white;
    width: 100%;
    height: 100%;
  }

  &.filled .circle {
    border-color: white;
  }

  &.frameless .circle {
    border-width: 0;
  }

  .image {
    width: 100%;
    height: 100%;
  }

  &.active .image,
  &.loading .image {
    opacity: 0.5;
  }

  .edit-button {
    border-color: white;
    background-color: white;
    border-radius: 50%;

    .icon {
      background-color: white;
      border-radius: 50%;
      border-color: #004e9e;
    }
  }
}

.ns-ios,
.ns-android {
  .avatar {
    width: 100;
    height: 100;

    .circle {
      border-radius: 55;
      border-width: 5;
    }

    &.frameless .circle {
      border-width: 0;
    }  

    .loader {
      width: 100;
      height: 100;
    }

    .edit-button {
      width: 38;
      height: 38;
    
      .icon {
        width: 34;
        height: 34;
        border-width: 2;
      }
    }
  }
}

html {
  .avatar {
    width: 100px;
    height: 100px;

    .circle {
      border-radius: 50%;
      border-width: 5px;
      border-style: solid;
    }

    .loader {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .edit-button {
      position: absolute;
      top: 62px;
      left: 62px;
      width: 38px;
      height: 38px;
      cursor: pointer;

      .icon {
        width: 34px;
        height: 34px;
        border-width: 2px;
        border-style: solid;
      }
    }

    @media (min-width: 800px) {
      width: 140px;
      height: 140px;

      .edit-button {
        top: 96px;
        left: 96px;
      }

      &::v-deep .icon .glyph {
        transform: scale(1.4);
      }

      &::v-deep .edit-button .icon .glyph {
        transform: scale(1);
      }
    }
  }
}

</style>